interface RoleDefinition {
    bitMask: number;
    title: string;
}

interface AccessLevelDefinition {
    bitMask: number;
    title: string | string[];
}

const ROLES = ['PUBLIC', 'RESPONSIBLE', 'ADMIN', 'ADVISOR', 'MANAGER'] as const;

const buildRoles = (roles: readonly string[]): Record<string, RoleDefinition> => {
    let bitMask = '01';
    const userRoles: Record<string, RoleDefinition> = {};

    roles.forEach((role) => {
        const intCode = parseInt(bitMask, 2);
        userRoles[role] = {
            bitMask: intCode,
            title: role
        };
        bitMask = (intCode << 1).toString(2);
    });

    return userRoles;
};

const buildAccessLevels = (
    accessLevelDeclarations: Record<string, string | string[]>,
    roles: Record<string, RoleDefinition>
): Record<string, AccessLevelDefinition> => {
    const accessLevels: Record<string, AccessLevelDefinition> = {};

    Object.entries(accessLevelDeclarations).forEach(([level, declaration]) => {
        if (typeof declaration === 'string') {
            if (declaration === '*') {
                let resultBitMask = '';
                Object.keys(roles).forEach(() => {
                    resultBitMask += '1';
                });
                accessLevels[level] = {
                    bitMask: parseInt(resultBitMask, 2),
                    title: declaration
                };
            }
            return;
        }

        let resultBitMask = 0;
        declaration.forEach((roleName) => {
            if (roles[roleName]) {
                resultBitMask |= roles[roleName].bitMask;
            }
        });

        accessLevels[level] = {
            bitMask: resultBitMask,
            title: declaration[declaration.length - 1]
        };
    });

    return accessLevels;
};

const userRoles = buildRoles(ROLES);

const routingConfig = {
    userRoles,
    accessLevels: buildAccessLevels(
        {
            PUBLIC: ['PUBLIC'],
            RESPONSIBLE: ['ADVISOR', 'ADMIN', 'RESPONSIBLE'],
            ADMIN: ['ADVISOR', 'ADMIN'],
            ADVISOR: ['ADVISOR'],
            MANAGER: ['MANAGER']
        },
        userRoles
    )
};

export default routingConfig;
